import { render } from "./CustomizationDiscardDialog.vue?vue&type=template&id=e4fc05ce"
import script from "./CustomizationDiscardDialog.vue?vue&type=script&lang=js"
export * from "./CustomizationDiscardDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__